module.exports = __webpack_public_path__ + "img/allotGame.eeb9fd93.png";